import { render, staticRenderFns } from "./group-row.vue?vue&type=template&id=6a13be22&scoped=true&"
import script from "./group-row.vue?vue&type=script&lang=js&"
export * from "./group-row.vue?vue&type=script&lang=js&"
import style0 from "./group-row.vue?vue&type=style&index=0&id=6a13be22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a13be22",
  null
  
)

export default component.exports